import API_BASE from "../config/api";

export const searchVehicleByChassis = async (searchText) => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Vehicle/List?type=2&search_text=${encodeURIComponent(searchText)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to search vehicle");
  }

  return await response.json();
};